export default {"src":"/_next/static/media/private_pool.83bba65a.svg","height":100,"width":100};